(function () {
  var el = document.getElementById('statesatelier-splash');
  if (!el) return;

  function hide(hold) {
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () { el.classList.add('is-off'); }, 400);
    }, hold);
  }
  function show() {
    el.classList.remove('is-off');
    el.classList.remove('is-out');
  }

  hide(450);

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[data-splash]') : null;
    if (!a) return;
    if (a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    show();
    var hold = parseInt(a.getAttribute('data-splash-hold') || '450', 10);
    setTimeout(function () { window.location.href = a.href; }, hold);
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) { show(); hide(450); } });
})();
